import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import App from "./App";
import ProtectedRoute from "./components/Routes/ProtectedRoute";
import { Login } from "./pages/login/Login";
import AboutUs from "./pages/About/AboutUs";
import TermsConditions from "./pages/About/termsCondition";
import PrivacyPolicy from "./pages/About/PrivacyPolicy";
import PublicRoute from "./components/Routes/PublicRoute";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

const AppWrapper = () => {
  let location = useLocation();

  React.useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, 0);
  }, [location]);

  return (
    // <Routes>
    //   <Route path="/login" element={<Login />} />
    //   <Route path="/" element={<AboutUs />} />
    //   <Route path="/terms-condition" element={<TermsConditions />} />
    //   <Route path="/privacy-policy" element={<PrivacyPolicy />} />

    //   {/* All protected routes below */}
    //   <Route element={<ProtectedRoute />}>
    //     <Route path="*" element={<App />} />
    //   </Route>
    // </Routes>

    <>
      <ScrollToTop />
      <Routes>
        {/* Guest-only section */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<AboutUs />} />
          <Route path="/terms-condition" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Route>

        {/* Protected section */}
        <Route element={<ProtectedRoute />}>
          <Route path="*" element={<App />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppWrapper;
